module.exports = __webpack_public_path__ + "static/media/preview_audio.6c4a0474.svg";